import 'regenerator-runtime/runtime'

import 'client/styles/main.global.css'
import 'client/styles/texts.global.css'
import 'client/styles/typography.global.css'
import 'client/pages/styles/StoriesPage.global.css'
import 'client/pages/styles/StoryViewPage.global.css'

import { useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, useLocation } from 'react-router-dom'
import App from 'routes/ssr/App'
import createStore from 'client/lib/create-store'
import isModernBrowser from 'client/lib/is-modern-browser'
;(function () {
  const _error = console.error.bind(console)

  console.error = function (...args) {
    if (args?.[0]?.isAxiosError) {
      console.error(args[0].toJSON())
      return
    }

    _error(...args)
  }
})()

export default function ScrollToTop () {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export const AppRouter = ({ store }) => (
  <BrowserRouter>
    <ScrollToTop />
    <App store={store} />
  </BrowserRouter>
)

const loadPolyfills = async () => {
  if ('ResizeObserver' in window === false) {
    const module = await import('@juggle/resize-observer')
    window.ResizeObserver = module.ResizeObserver
  }
  const isModern = isModernBrowser(navigator.userAgent)

  if (!isModern) {
    await import('core-js/stable')
  }
}

const main = async () => {
  await loadPolyfills()

  // Create store without SSR initial state
  const { store } = createStore({}, null, {})

  // Use createRoot for client-side rendering (not hydrateRoot)
  // Note: dev server uses 'scite-app', static build uses 'root'
  const container = document.getElementById('scite-app') || document.getElementById('root')
  if (!container) {
    console.error('Container element not found')
    return
  }
  const root = createRoot(container)
  root.render(<AppRouter store={store} />)
}

if (!CONFIG.maintenance) {
  window.addEventListener('load', main)
}
